module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/filetypes-pdf-42ca066206fd5546dd5e35b13b1f3c51.svg";